import React from "react";
import Explainer from "../ExplainerModal";

const FAQsExplainer = () => {
  return (
    <Explainer
      title="❓ Frequently Asked Questions (FAQs)"
      content={
        <>
          <h3 style={{ fontSize: "20px", fontWeight: "bold", marginBottom: "10px", color: "#137A08" }}>
            🔍 About This Section
          </h3>
          <p>
            The FAQs section provides clear and concise answers to the most common questions
            related to the platform. It serves as a quick reference guide to help users navigate
            features, understand processes, and resolve common issues.
          </p>

          <h3 style={{ fontSize: "18px", fontWeight: "bold", marginTop: "15px", color: "#333" }}>
            📌 What to Expect
          </h3>
          <p>
            Here, users will find structured responses addressing various aspects of the platform,
            ensuring a smooth user experience. Whether it's functionality, policy tracking, or
            data management, this section provides essential insights in a straightforward manner.
          </p>
        </>
      }
    />
  );
};

export default FAQsExplainer;
